module.exports = __webpack_public_path__ + "static/media/ca_phe_hanoi_thumb.9be50f96.jpg";